import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import StorageDriverService from 'app/admin/driver/service/StorageDriverService';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormFileInputField from 'modules/ui/editform/fields/EditFormFileInputField';
import EditFormFreeSoloField from 'modules/ui/editform/fields/EditFormFreeSoloField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import EditFormComponentMassSomethingField from 'app/admin/common/component/EditFormComponentMassSomethingField';
import { useParams, withRouter } from 'react-router';
import ModelCalculate from 'app/admin/common/component/ModelCalculate';
import EntriesListComponent from 'app/admin/model/component/EntriesListComponent';
import VariableType from 'app/admin/modelSpreadsheet/dto/VariableType';
import SpreadsheetModelEditService from '../service/SpreadsheetModelEditService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = data => {
	const storageDriverService = new StorageDriverService();
	return {
		key: 'spreadsheetModelEditForm',
		topic: 'model',
		service: SpreadsheetModelEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'inputAttributes' }, { key: 'outputAttributes' }/*, { key: 'entries' }*/];
		},
		backLink: () => '/model',
		defaultValue: () => SpreadsheetModelEditService.create(data.driverName),
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'driver',
					component: EditFormSelectField,
					required: true,
					items: () => storageDriverService.getListSelectionByDriverType('spreadsheet')
				},
				{
					key: 'version',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				// {
				// 	key: 'entries',
				// 	component: EntriesListComponent,
				// 	isControlledInput: false,
				// 	required: true,
				// 	method: 'spreadSheetModelEditControl/addModelEntry',
				// 	types: [
				// 		{ name: 'Worksheet', fieldName: 'xlsFile', accept: '.xls,.xlsx' }
				// 	],
				// 	tab: 'entries'
				// },
				// {
				// 	key: 'model_zip_file',
				// 	component: EditFormFileInputField,
				// 	required: true
				// },
				// {
				// 	key: 'xscaler_file',
				// 	component: EditFormFileInputField,
				// 	required: true
				// },
				// {
				// 	key: 'yscaler_file',
				// 	component: EditFormFileInputField,
				// 	required: true
				// },
				// {
				// 	key: 'state_file',
				// 	component: EditFormFileInputField,
				// 	required: true
				// },
				{
					key: 'image',
					component: EditFormFileInputField,
					required: true
				},
				{
					key: 'inputAttributes',
					tab: 'inputAttributes',
					component: EditFormGridComponent,
					orderable: true,
					defaultValue: {
						id: null,
						name: null,
						value: null,
						minValue: null,
						maxValue: null,
						uom: null,
						worksheet: null,
						cell: null,
						orderIndex: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							type: 'enum',
							items: Object.keys(VariableType).map(key => {
								return { label: VariableType[key], value: key };
							})
						},
						{
							key: 'value',
							component: EditFormTextField,
							required: true,
							type: 'number',
							dependsOn: 'type',
							visibleIf: type => type !== 'ComponentMassFrac'
						},
						// {
						// 	key: 'minValue',
						// 	component: EditFormTextField,
						// 	required: true,
						// 	type: 'number',
						// 	dependsOn: 'type',
						// 	visibleIf: type => type !== 'ComponentMassFrac'
						// },
						// {
						// 	key: 'maxValue',
						// 	component: EditFormTextField,
						// 	required: true,
						// 	type: 'number',
						// 	dependsOn: 'type',
						// 	visibleIf: type => type !== 'ComponentMassFrac'
						// },
						{
							key: 'value',
							component: EditFormComponentMassSomethingField,
							type: 'MIN_MAX',
							minValueField: 'minValue',
							maxValueField: 'maxValue',
							dependsOn: 'type',
							visibleIf: type => type === 'ComponentMassFrac'
						},
						{
							key: 'uom',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'worksheet',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'cell',
							component: EditFormTextField,
							required: true
						}
					]
				},
				{
					key: 'outputAttributes',
					tab: 'outputAttributes',
					component: EditFormGridComponent,
					orderable: true,
					defaultValue: {
						id: null,
						name: null,
						uom: null,
						worksheet: null,
						cell: null,
						orderIndex: null,
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							type: 'enum',
							items: Object.keys(VariableType).map(key => {
								return { label: VariableType[key], value: key };
							})
						},
						// {
						// 	key: 'components',
						// 	component: EditFormFreeSoloField,
						// 	required: true,
						// 	multiple: true,
						// 	query: () => new Promise(resolve => resolve([])),
						// 	dependsOn: 'type',
						// 	visibleIf: type => type === 'ComponentMassFrac'
						// },
						{
							key: 'value',
							component: EditFormComponentMassSomethingField,
							dependsOn: 'type',
							visibleIf: type => type === 'ComponentMassFrac'
						},
						{
							key: 'uom',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'worksheet',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'cell',
							component: EditFormTextField,
							required: true
						}
					]
				}
			];

			return fields;
		}
	};
};

function SpreadsheetModelEditForm() {
	const { id, driverName } = useParams();
	const dispatch = useDispatch();

	const myConfig = config({ id, driverName });
	return (
		<EditFormPage
			config={myConfig}
			beforeSaveContent={<ModelCalculate id={id} type="model" />}
		// onSave={result => { if (!result.engineSuccessful) dispatch(showMessage({ message: `Engine: ${result.engineMessage}` })); }}
		/>
	);
}

export default withRouter(SpreadsheetModelEditForm);
